import React, { useState } from "react";
import "antd/dist/antd.css";
import { Col, Button } from "antd";
import styles from "./DashBoard.module.scss";
import textStyles from "../../components/DashBoard/BookingSummary/BookingSummary.module.scss";
import { FilterCalendarIcon, leftOutlinedIcon } from "../../assets/images";
import moreOutlined from "../../assets/icons/moreOutlined.svg";

type FilterDateProps = {
  getDateRange: () => string;
  showDrawer: () => void;
};

const DashBoardFilterButton: React.FC<FilterDateProps> = ({
  getDateRange,
  showDrawer,
}) => {
  return (
    <>
      <Col span={8} className={styles.contentRight}>
        <Button className={styles.filterButtonStyle} onClick={showDrawer}>
          <img
            className={styles.threeDotStyle}
            src={moreOutlined}
            alt="filter-three-dot"
          />{" "}
          <span
            className={`${textStyles.normalText14} ${styles.filterTestStyle}`}
          >
            Filters
          </span>
        </Button>
      </Col>
      <Col xs={24} className={styles.filterDateStyle}>
        <img
          className={styles.calendarIconStyle}
          src={FilterCalendarIcon}
          alt="calander-icon"
        />{" "}
        <span className={textStyles.normalText16}> {getDateRange()}</span>
      </Col>
    </>
  );
};

export default DashBoardFilterButton;
